<form [formGroup]="datePicker" (ngSubmit)="viewReport(datePicker)">
    <mat-form-field class="mat-form-field-fluid">
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="picker" (dateChange)="onValueChange($event,datePicker)" formControlName="start"
            readonly>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="!datePicker.controls['start'].value">
            required
        </mat-error>
    </mat-form-field>
    <mat-form-field class="mat-form-field-fluid" style="margin-left: 10px;">
        <mat-label>End Date</mat-label>
        <input matInput [matDatepicker]="picker1" [min]="minDate" formControlName="end" readonly>
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
        <mat-error *ngIf="!datePicker.controls['end'].value">
            required
        </mat-error>
    </mat-form-field>
    <button type="submit" class="btn btn-primary" style="margin-left: 10px;">View</button>
</form>